module.exports = __webpack_public_path__ + "img/getCat.0a19790f.svg";